import { authAxios } from "../config"
import { ApiKey } from "../endpoints";

export const getCategory = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.GetMasterTechnologiesCategory}`,data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const addNewCategory = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.AddMasterTechnologiesCategory}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const updateCategory = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.UpdateMasterTechnologiesCategory}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}

export const ChangeCategoryStatus = async(data) => {
    try{
var response = await authAxios.post(`${ApiKey.ChangeMasterTechnologiesCategoryStatus}`, data);
var LatestResponse =  response.data;
return LatestResponse;
}
catch(err){
return err;
}
}